import React from "react";
import { Routes, Route } from "react-router-dom";
import RealtimeDataManager from "./RealtimeDataManager";

interface RealtimeDataWrapperProps {
  authToken: string;
}

const RealtimeDataWrapper: React.FC<RealtimeDataWrapperProps> = ({
  authToken,
}) => {
  return (
    <Routes>
      <Route index element={<RealtimeDataManager authToken={authToken} />} />
      <Route
        path="manual"
        element={<RealtimeDataManager authToken={authToken} />}
      />
      <Route
        path="api"
        element={<RealtimeDataManager authToken={authToken} />}
      />
    </Routes>
  );
};

export default RealtimeDataWrapper;
